import proofkitFilemakerService from './proofkitFilemakerService.js';

const LAYOUT = process.env.REACT_APP_FILEMAKER_LAYOUT_RAMOS || 'ramos';

export const getRamos = async () => {
  const response = await proofkitFilemakerService.getAllRecords(LAYOUT);
  const rows = Array.isArray(response?.data) ? response.data : [];

  return rows.map((item) => ({
    id: item.fieldData?.id || item.recordId,
    recordId: item.recordId,
    nombre: item.fieldData?.nombre || '',
    codigo: item.fieldData?.codigo || '',
    descripcion: item.fieldData?.descripcion || ''
  }));
};

export const getRamoById = async (recordId) => {
  const response = await proofkitFilemakerService.getRecord(LAYOUT, recordId);
  const item = response?.data;

  if (!item) return null;

  return {
    id: item.fieldData?.id || item.recordId,
    recordId: item.recordId,
    nombre: item.fieldData?.nombre || '',
    codigo: item.fieldData?.codigo || '',
    descripcion: item.fieldData?.descripcion || ''
  };
};

export const createRamo = async (ramoData) => {
  const payload = {
    nombre: ramoData.nombre,
    codigo: ramoData.codigo || null,
    descripcion: ramoData.descripcion || null
  };

  return await proofkitFilemakerService.createRecord(LAYOUT, payload);
};

export const updateRamo = async (recordId, ramoData) => {
  const payload = {
    nombre: ramoData.nombre,
    codigo: ramoData.codigo || null,
    descripcion: ramoData.descripcion || null
  };

  return await proofkitFilemakerService.updateRecord(LAYOUT, recordId, payload);
};

export const deleteRamo = async (recordId) => {
  await proofkitFilemakerService.deleteRecord(LAYOUT, recordId);
  return true;
};